import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

interface RowActionsMenuProps {
  children: React.ReactNode;
}

export const RowActionsMenu: React.FC<RowActionsMenuProps> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [coords, setCoords] = useState({ top: 0, right: 0 });
  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = () => setOpen(false);
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => {
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [open]);

  const toggle = () => {
    if (!open && btnRef.current) {
      const r = btnRef.current.getBoundingClientRect();
      setCoords({ top: r.bottom + 4, right: window.innerWidth - r.right });
    }
    setOpen((o) => !o);
  };

  return (
    <>
      <button
        ref={btnRef}
        className="eval-btn-ghost"
        title="Actions"
        onClick={toggle}
        style={{ padding: 4, minWidth: 0, lineHeight: 0 }}
      >
        <MoreVertIcon style={{ fontSize: 18 }} />
      </button>
      {open &&
        createPortal(
          <>
            <div
              style={{ position: 'fixed', inset: 0, zIndex: 1000 }}
              onClick={() => setOpen(false)}
            />
            <div
              onClick={() => setOpen(false)}
              style={{
                position: 'fixed',
                top: coords.top,
                right: coords.right,
                zIndex: 1001,
                minWidth: 180,
                background: 'var(--elevated)',
                border: '1px solid var(--border)',
                borderRadius: 6,
                boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
                padding: 4,
              }}
            >
              {children}
            </div>
          </>,
          document.querySelector('.forge-root') ?? document.body
        )}
    </>
  );
};

export const RowActionsMenuItem: React.FC<
  React.PropsWithChildren<{ onClick: () => void; danger?: boolean }>
> = ({ onClick, danger, children }) => (
  <button
    onClick={onClick}
    style={{
      display: 'block',
      width: '100%',
      textAlign: 'left',
      padding: '8px 12px',
      background: 'transparent',
      border: 'none',
      borderRadius: 4,
      color: danger ? 'var(--danger)' : 'var(--text-primary)',
      fontSize: 13,
      cursor: 'pointer',
      whiteSpace: 'nowrap',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = 'rgba(127,127,127,0.15)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = 'transparent';
    }}
  >
    {children}
  </button>
);
